import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { useQuery } from "@tanstack/react-query";
import * as axiosInstance from "../services/axiosInstance";
import * as StorageManager from "../utils/StorageManager";
import constants from "../constants";
import * as commonActions from "../action/common";
import * as toolSelectors from "../selectors/tool";

export const withTransactionCostConfig = (WrappedComponent) => {
    function WithTransactionCostConfig(props) {
        const configData = useSelector((state) => toolSelectors.getCommonTransactionData(state));
        const dispatch = useDispatch();
        const [token, setToken] = useState(null);
        useEffect(() => {
            StorageManager.retrieveToken(constants.AUTH_TOKEN).then((value) => {
                setToken(value);
            });
        }, []);

        const { isLoading, data } = useQuery({
            queryKey: ["transaction-charges-config"],
            queryFn: async () => {
                try {
                    return await axiosInstance.get(`/clientarea/config/transaction-charges`);
                } catch (e) {}
            },
            retryDelay: 15000,
            enabled: !_.isEmpty(token) && _.isEmpty(configData),
        });

        useEffect(() => {
            dispatch(commonActions.setTransactionConfigData(data));
        }, [data]);
        return <WrappedComponent {...props} loading={isLoading} configData={configData} />;
    }

    return WithTransactionCostConfig;
};
